const actionTypes = {
    USER_NAME: 'username',
    CURRENT_LOCATION: 'currentLocation'
}
export default actionTypes;



// WEBPACK FOOTER //
// ./src/store/constant/constants.js